import { OperatingHours, RestaurantTheme } from "../types/restaurant";
import { colorPalettes } from "./colorPalette";

export const defaultTheme: RestaurantTheme = {
	...colorPalettes[0],
	fontFamily: 'Inter',
	borderRadius: '0',
	headerStyle: 'transparent',
	cardStyle: 'minimal',
	menuStyle: 'grid',
	SubcategoryStyle: 'tabs',
	itemFontSize: 'text-sm',
	titleFontSize: 'text-lg',
	boldTitles: false,
	isOnePageLayout: false,
	isAddToCart: true,
}

export const defaultOperatingHours: OperatingHours[] = [
	{ day: "monday", opening_time: "09:00", closing_time: "22:00", is_closed: false },
	{ day: "tuesday", opening_time: "09:00", closing_time: "22:00", is_closed: false },
	{ day: "wednesday", opening_time: "09:00", closing_time: "22:00", is_closed: false },
	{ day: "thursday", opening_time: "09:00", closing_time: "22:00", is_closed: false },
	{ day: "friday", opening_time: "09:00", closing_time: "22:00", is_closed: false },
	{ day: "saturday", opening_time: "09:00", closing_time: "22:00", is_closed: false },
	{ day: "sunday", opening_time: "09:00", closing_time: "22:00", is_closed: false },
]